{
  "required": "Ruangan ini diperlukan",
  "email": "Masukkan alamat e-mel yang sah",
  "minLength": "Mestilah sekurang-kurangnya {{count}} aksara",
  "maxLength": "Mestilah tidak melebihi {{count}} aksara"
}
